module.exports = __webpack_public_path__ + "components/panel/check-yeti/static/check-yeti--it-3d395015d4833ff4ccd0b87c552766b0.webp";